// extracted by mini-css-extract-plugin
module.exports = {"card":"ShareForm_card__1xjBM","form":"ShareForm_form__FiTZP","stackable":"ShareForm_stackable__2Mmpb"};